import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const styles = {
  root: {
    borderRadius: '12px',
    p: 1.75,
    mb: 2,
    display: 'flex',
    gap: 1,
    alignItems: 'flex-start',
    bgcolor: 'background.default',
  },
  text: (theme) => ({
    fontSize: theme.typography.pxToRem(13),
    color: 'text.secondary',
    lineHeight: 1.5,
  }),
  title: {fontWeight: 'bold', color: 'secondary.main'},
};

// Shared visual pattern for Renewal Click's info notes (offer disclaimer, payment cancellation note, ...).
const DisclaimerNote = ({icon, title, children}) => (
  <Box sx={styles.root}>
    {icon}
    <Typography sx={styles.text}>
      {title && (
        <Box component='span' sx={styles.title}>
          {title}{' '}
        </Box>
      )}
      {children}
    </Typography>
  </Box>
);

DisclaimerNote.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.node.isRequired,
  title: PropTypes.node,
};

export default DisclaimerNote;
